import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectRootIdsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectRootIdsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, name: string, rootAssetId: string, workspaceId: string, viewerRootCollection?: { __typename?: 'Collection', id: string, rootAsset?: { __typename?: 'FolderAsset', id: string } | null } | null } | null } | null };


export const GetProjectRootIds = /*#__PURE__*/ gql`
    query GetProjectRootIds($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      name
      rootAssetId
      workspaceId
      viewerRootCollection {
        id
        rootAsset {
          id
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetProjectRootIdsQuery, GetProjectRootIdsQueryVariables>;

          

          export const useGetProjectRootIdsQuery = (options?:QueryHookOptions<GetProjectRootIdsQuery, GetProjectRootIdsQueryVariables>) => useQuery(GetProjectRootIds, options);

          

          export type GetProjectRootIdsQueryOptions = QueryHookOptions<GetProjectRootIdsQuery, GetProjectRootIdsQueryVariables>;

          

          export const useGetProjectRootIdsLazyQuery = (options?:LazyQueryHookOptions<GetProjectRootIdsQuery, GetProjectRootIdsQueryVariables>) => useLazyQuery(GetProjectRootIds, options);

          

          export type GetProjectRootIdsQueryResult = ReturnType<typeof useGetProjectRootIdsQuery>;

          
